<header class="hdr" [class.is-stuck]="stuck()">
  <div class="hdr__bar">
    <a class="hdr__logo" href="#top" aria-label="Little Nap Recliners — back to top">
      <img src="assets/logo.png" alt="Little Nap Recliners — Joy of Comfort" width="790" height="481" />
    </a>

    <!-- centred links on a wide screen; a drawer from the right on a narrow one -->
    <nav id="site-menu" class="hdr__nav" [class.is-open]="open()" aria-label="Primary">
      <div class="hdr__nav-head">
        <img src="assets/logo.png" alt="" width="790" height="481" loading="lazy" />
        <button type="button" class="hdr__icon-btn" aria-label="Close menu" (click)="close()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </div>

      <ul class="hdr__list">
        <li
          class="hdr__item hdr__item--sub"
          [class.is-open]="expanded()"
          [class.is-dismissed]="dismissed()"
          (mouseleave)="dismissed.set(false)"
        >
          <button
            type="button"
            class="hdr__link"
            [class.is-active]="current() === 'collections'"
            [attr.aria-expanded]="expanded()"
            aria-controls="collections-menu"
            (click)="expanded.set(!expanded())"
          >
            Collections
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
          </button>

          <ul id="collections-menu" class="sub">
            @for (category of categories; track category.id) {
              <li class="sub__item" [class.is-open]="category.links.length && nestedOpen() === category.id">
                <a class="sub__link" href="#collections" (click)="pick(category.id)">
                  <span class="sub__icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path [attr.d]="category.icon" /></svg>
                  </span>
                  <span class="sub__label">{{ category.label }}</span>
                  <svg class="sub__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6" /></svg>
                </a>
                @if (category.links.length) {
                  <!-- (in the drawer only: folds this category's links open) -->
                  <button
                    type="button"
                    class="sub__toggle"
                    [attr.aria-label]="'Show ' + category.label"
                    [attr.aria-expanded]="nestedOpen() === category.id"
                    (click)="nestedOpen.set(nestedOpen() === category.id ? '' : category.id)"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
                  </button>
                  <ul class="sub sub--nested" [attr.aria-label]="category.label">
                    @for (link of category.links; track link.href) {
                      <li>
                        <a class="sub__link" [href]="link.href" target="_blank" rel="noopener" (click)="dismiss()">
                          <span class="sub__label">{{ link.label }}</span>
                          <svg class="sub__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7M9 7h8v8" /></svg>
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </li>

        @for (link of nav; track link.href) {
          <li class="hdr__item">
            <a
              class="hdr__link"
              [class.is-active]="!link.external && current() === link.href.slice(1)"
              [href]="link.href"
              [attr.target]="link.external ? '_blank' : null"
              [attr.rel]="link.external ? 'noopener' : null"
              (click)="close()"
            >
              {{ link.label }}
            </a>
          </li>
        }
      </ul>

      <div class="hdr__nav-foot">
        <a class="hdr__login" [href]="account.login" target="_blank" rel="noopener" (click)="login($event)">
          <span class="hdr__login-name">{{ popups.account() ?? 'Login' }}</span>
          <span class="hdr__login-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 20a7 7 0 0 1 14 0" /></svg>
          </span>
        </a>
      </div>
    </nav>

    <div class="hdr__actions">
      <a class="hdr__icon-btn hdr__cart" [href]="account.cart" target="_blank" rel="noopener" aria-label="Cart">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2.2l2.3 11h10.2L20 7.5H6.3M9.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM16.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" /></svg>
      </a>
      <a class="hdr__login" [href]="account.login" target="_blank" rel="noopener" (click)="login($event)">
        <span class="hdr__login-name">{{ popups.account() ?? 'Login' }}</span>
        <span class="hdr__login-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM5 20a7 7 0 0 1 14 0" /></svg>
        </span>
      </a>
      <button
        type="button"
        class="hdr__icon-btn hdr__burger"
        [attr.aria-expanded]="open()"
        aria-controls="site-menu"
        aria-label="Open menu"
        (click)="open.set(true)"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16" /></svg>
      </button>
    </div>
  </div>

  <div class="hdr__backdrop" [class.is-visible]="open()" (click)="close()"></div>
</header>
